import { STEP_DONE } from './constants';
import { snakeCase } from 'lodash';

export const getStepPath = (
  propertyType: string,
  step: number | 'DONE',
): string => {
  const stepName = step === 'DONE' ? STEP_DONE : `STEP_${step}`;
  return `/property_type_steps/${snakeCase(propertyType)}/${stepName}.svg`;
};
